import styled from 'styled-components';

export const Text = styled.div`
  margin-top: 30px;
  width: 216px;
  font-family: Montserrat;
  font-weight: 400;
  font-size: 15px;
  line-height: 23px;
  color: #7C839C;
  
  @media(max-height: 600px){
    &{
      font-size: 12px;
    }
  }
`;
